import React from 'react';

function CommentSkeletonCard() {
  return (
    <div
      className="rounded-lg border border-gray-100 bg-gray-50 px-3 py-2.5 animate-pulse"
      aria-hidden
    >
      <div className="h-3 w-24 rounded bg-gray-200" />
      <div className="mt-2 space-y-1.5">
        <div className="h-3 w-full rounded bg-gray-200" />
        <div className="h-3 w-[85%] rounded bg-gray-200" />
      </div>
      <div className="mt-2 h-2.5 w-20 rounded bg-gray-200" />
    </div>
  );
}

export default CommentSkeletonCard;
